import './OfferDetailsStyle.less';

import React, { Component } from 'react';

import { IBrokerageInfo } from '../../declarations';
import imgixUrl from '../../helpers/imgixUrl';
import Responsive from '../../hocs/Responsive';
import DeclineModal, { IDeclineModalProps } from './DeclineModal';
import SideBySideCalculator, { ISBSCalculatorProps } from './SideBySideCalculator';
import StepCardList from './StepCardList';

export interface IOfferDetailsProps {
  brokerageInfo: IBrokerageInfo;
  calculatorColumns: ISBSCalculatorProps['columns'];
  calculatorState: ISBSCalculatorProps['calculatorState'];
  calculatorFields: ISBSCalculatorProps['fields'];
  hideDeclineOfferModal: IDeclineModalProps['closeModal'];
  isShowingDeclineModal: IDeclineModalProps['isOpen'];
  onDeclineSubmit: IDeclineModalProps['onDeclineSubmit'];
  onUpdate: ISBSCalculatorProps['onUpdate'];
  streetAddress: string;
}

class OfferDetails extends Component<IOfferDetailsProps> {
  public renderStepCards = ({ gtSM }) => {
    return (
      <section
        className="od-offer-details__step-section"
        style={{
          backgroundImage: `url(${imgixUrl('24f4bd0492404f0baa375d176ab5aa07.jpg')})`,
          backgroundSize: gtSM ? 'cover' : '0 0',
        }}
      >
        <h2 className="text-center extra-bottom-margin">What happens next</h2>
        <StepCardList
          steps={[
            {
              content:
                'Sign your purchase agreement and choose your preferred close date \
                          anytime from 21 to 60 days from the date your offer is accepted',
              title: 'Choose your move-out date',
            },
            {
              content:
                "Once you've signed a purchase agreement, the Buyer will do a quick, free \
                          home assessment to confirm your home's condition.",
              title: 'Schedule your inspection',
            },
            {
              content: `${
                this.props.brokerageInfo.name
              } will provide the paperwork for your review. You'll get the
                          proceeds from your home sale on your close date.`,
              title: "We'll handle the details",
            },
          ]}
        />
      </section>
    );
  };

  public render() {
    return (
      <div className="od-offer-details">
        <div className="od-offer-details__hero">
          <h1>
            Your offer for
            <br />
            {this.props.streetAddress}
          </h1>
        </div>
        <div className="container od-offer-details__calculator">
          <SideBySideCalculator
            calculatorState={this.props.calculatorState}
            columns={this.props.calculatorColumns}
            fields={this.props.calculatorFields}
            onUpdate={this.props.onUpdate}
          />
        </div>
        <section className="small-container">
          <p className="text-center text-muted">
            These figures are estimates. You'll have a better sense of your potential net proceeds
            once a repairs assessment has taken place.
          </p>
        </section>
        <Responsive render={this.renderStepCards} />
        <section className="container">
          <h2 className="text-center section-header">Frequently asked questions</h2>
          <div className="row">
            <div className="col-xs-12 col-md-6 large-margin-bottom">
              <h6 className="prose">What are the next steps to move forward with this offer?</h6>
              <div className="medium-margin-top">
                First, select the "Next: Purchase Agreement" button at the bottom of your screen.
                We'll have you answer a few questions before generating a contract. You have four
                days to review the contract before electronically signing it. Upon signing the
                contract, you can schedule your free home assessment.
              </div>
            </div>
            <div className="col-xs-12 col-md-6 large-margin-bottom">
              <h6 className="prose">
                What kind of repairs are taken into account during the home inspection?
              </h6>
              <div className="medium-margin-top">
                The buyer generally looks for items that are broken, inoperable, or affect the
                safety, structure, or functionality of the home. Typical items include the roof,
                foundation, electrical, plumbing or any of the major systems or appliances such as
                the AC unit.
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <h6 className="prose">
                Can I cancel the contract if I disagree with the repair amount?
              </h6>
              <div className="medium-margin-top">
                Yes, you can cancel at any point prior to the close of escrow, penalty-free. The
                buyer wants you to feel confident about your sale so you can move on to what's next.
              </div>
            </div>
          </div>
        </section>
        <DeclineModal
          closeModal={this.props.hideDeclineOfferModal}
          isOpen={this.props.isShowingDeclineModal}
          onDeclineSubmit={this.props.onDeclineSubmit}
          offerTooLowFeedbackEnabled={false}
        />
      </div>
    );
  }
}

export default OfferDetails;
